import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wifi-admin-page" }
const _hoisted_2 = { class: "stats-grid" }
const _hoisted_3 = { class: "stat-card stat-card--blue" }
const _hoisted_4 = { class: "stat-card__value" }
const _hoisted_5 = { class: "stat-card stat-card--orange" }
const _hoisted_6 = { class: "stat-card__value" }
const _hoisted_7 = { class: "stat-card stat-card--purple" }
const _hoisted_8 = { class: "stat-card__value" }
const _hoisted_9 = { class: "table-card" }
const _hoisted_10 = { class: "toolbar" }
const _hoisted_11 = { class: "toolbar__actions" }
const _hoisted_12 = { class: "pagination-row" }

import { onMounted, reactive, ref } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { useApi } from '@/hooks/useApi';
import type { QrWifiCode, QrWifiSummary } from '@/api';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const loading = ref(false);
const dialogVisible = ref(false);
const tableData = ref<QrWifiCode[]>([]);
const total = ref(0);
const summary = reactive<QrWifiSummary>({
  codeCount: 0,
  yesterdayConnectCount: 0,
  totalConnectCount: 0,
});
const query = reactive({
  keyword: '',
  page: 1,
  pageSize: 10,
});
const form = reactive<QrWifiCode>({
  storeName: '',
  ssid: '',
  password: '',
  enabled: 1,
});

const resetForm = () => {
  form.id = undefined;
  form.storeName = '';
  form.ssid = '';
  form.password = '';
  form.enabled = 1;
};

const loadSummary = async() => {
  const res = await useApi().qrWifiApi.getSummary();
  if (res.success && res.data) {
    Object.assign(summary, res.data);
  }
};

const loadData = async() => {
  loading.value = true;
  try {
    const res = await useApi().qrWifiApi.pageWifiCodes(query.keyword, query.page, query.pageSize);
    if (res.success && res.data) {
      tableData.value = res.data.data;
      total.value = res.data.total;
    }
    await loadSummary();
  } finally {
    loading.value = false;
  }
};


const openEdit = (row: QrWifiCode) => {
  Object.assign(form, row);
  dialogVisible.value = true;
};

const assertForm = () => {
  if (!form.storeName || !form.ssid || !form.password) {
    ElMessage.warning('请填写店铺名称、WiFi名称和WiFi密码');
    return false;
  }
  return true;
};

const save = async() => {
  if (!assertForm()) {
    return;
  }
  if (!form.id) {
    ElMessage.warning('后台只允许修改已有店铺');
    return;
  }
  const res = await useApi().qrWifiApi.updateWifiCode(form);
  if (res.success) {
    ElMessage.success('保存成功');
    dialogVisible.value = false;
    await loadData();
  }
};

const toggleEnabled = async(row: QrWifiCode) => {
  await useApi().qrWifiApi.updateWifiCode({
    id: row.id,
    enabled: row.enabled === 1 ? 0 : 1,
  });
  ElMessage.success('状态已更新');
  await loadData();
};

const remove = async(row: QrWifiCode) => {
  await ElMessageBox.confirm(`确定删除「${row.storeName}」的店铺吗？`, '删除确认', {
    type: 'warning',
  });
  if (!row.id) {
    return;
  }
  await useApi().qrWifiApi.deleteWifiCode(row.id);
  ElMessage.success('删除成功');
  await loadData();
};

onMounted(loadData);

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[17] || (_cache[17] = _createElementVNode("section", { class: "hero-panel" }, [
      _createElementVNode("div", null, [
        _createElementVNode("p", { class: "eyebrow" }, "QRWiFi"),
        _createElementVNode("h1", null, "店铺管理"),
        _createElementVNode("p", { class: "description" }, "复刻小程序“碰联生活”设计稿的后台管理端，统一管理店铺、WiFi密码与连接数据。")
      ])
    ], -1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "stat-card__label" }, "店铺数量", -1)),
        _createElementVNode("div", _hoisted_4, _toDisplayString(summary.codeCount), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "stat-card__label" }, "昨日连接", -1)),
        _createElementVNode("div", _hoisted_6, _toDisplayString(summary.yesterdayConnectCount), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "stat-card__label" }, "累计连接", -1)),
        _createElementVNode("div", _hoisted_8, _toDisplayString(summary.totalConnectCount), 1)
      ])
    ]),
    _createElementVNode("section", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _cache[12] || (_cache[12] = _createElementVNode("div", null, [
          _createElementVNode("h2", null, "店铺列表"),
          _createElementVNode("p", null, "对齐小程序“我的店铺”列表，支持搜索、修改、停用和删除。")
        ], -1)),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_input, {
            modelValue: query.keyword,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((query.keyword) = $event)),
            clearable: "",
            placeholder: "搜索店铺名称或WiFi名",
            class: "search-input",
            onKeyup: _withKeys(loadData, ["enter"]),
            onClear: loadData
          }, null, 8, ["modelValue"]),
          _createVNode(_component_el_button, { onClick: loadData }, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
              _createTextVNode("搜索", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        border: "",
        stripe: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "storeName",
            label: "店铺名称",
            "min-width": "180"
          }),
          _createVNode(_component_el_table_column, {
            prop: "ssid",
            label: "WiFi名称 / SSID",
            "min-width": "180"
          }),
          _createVNode(_component_el_table_column, {
            prop: "password",
            label: "WiFi密码",
            "min-width": "150"
          }),
          _createVNode(_component_el_table_column, {
            prop: "yesterdayConnectCount",
            label: "昨日连接",
            width: "110",
            align: "right"
          }),
          _createVNode(_component_el_table_column, {
            prop: "totalConnectCount",
            label: "累计连接",
            width: "110",
            align: "right"
          }),
          _createVNode(_component_el_table_column, {
            label: "状态",
            width: "90",
            align: "center"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_tag, {
                type: row.enabled === 1 ? 'success' : 'info'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(row.enabled === 1 ? '启用' : '停用'), 1)
                ]),
                _: 2
              }, 1032, ["type"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            width: "220",
            fixed: "right"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_button, {
                link: "",
                type: "primary",
                onClick: ($event: any) => (openEdit(row))
              }, {
                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                  _createTextVNode("修改", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_button, {
                link: "",
                type: "warning",
                onClick: ($event: any) => (toggleEnabled(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(row.enabled === 1 ? '停用' : '启用'), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                link: "",
                type: "danger",
                onClick: ($event: any) => (remove(row))
              }, {
                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                  _createTextVNode("删除", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, loading.value]
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_el_pagination, {
          "current-page": query.page,
          "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((query.page) = $event)),
          "page-size": query.pageSize,
          "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((query.pageSize) = $event)),
          background: "",
          layout: "prev, pager, next, sizes, total",
          total: total.value,
          onCurrentChange: loadData,
          onSizeChange: loadData
        }, null, 8, ["current-page", "page-size", "total"])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((dialogVisible).value = $event)),
      title: "修改店铺",
      width: "520px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (dialogVisible.value = false))
        }, {
          default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
            _createTextVNode("取消", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: save
        }, {
          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
            _createTextVNode("保存", -1)
          ]))]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: form,
          "label-width": "110px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "店铺名称",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.storeName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.storeName) = $event)),
                  placeholder: "请输入店铺名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "WiFi名称",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.ssid,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.ssid) = $event)),
                  placeholder: "请输入SSID"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "WiFi密码",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.password,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.password) = $event)),
                  placeholder: "请输入WiFi密码"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})